
import React from 'react';
import { cn } from '@/lib/utils';
import ProgressBar from './ProgressBar';

interface FormLayoutProps {
  children: React.ReactNode;
  progressPercentage: number;
  className?: string;
}

const FormLayout: React.FC<FormLayoutProps> = ({ 
  children, 
  progressPercentage,
  className 
}) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-start py-1 px-0 sm:py-4 sm:px-4">
      <div 
        className="absolute inset-0 -z-10 bg-gradient-to-b from-primary/5 to-secondary/5" 
        aria-hidden="true" 
      />
      
      <div className="w-full max-w-3xl mx-auto">
        <ProgressBar 
          percentage={progressPercentage} 
          className="mb-3 sm:mb-5 mt-2" 
        />
        
        <div className={cn(
          "w-full bg-white/80 backdrop-blur-sm rounded-md sm:rounded-lg transition-all duration-300 px-2 py-3 sm:px-6 sm:py-5",
          className
        )}>
          <div className="animate-fade-in">
            {children}
          </div>
        </div>
        
        {/* Footer with logo */}
        <div className="mt-4 mb-6 flex flex-col items-center justify-center text-center">
          <p className="text-sm text-muted-foreground mb-2">Powered by</p>
          <a 
            href="https://lexassessai.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center hover:opacity-80 transition-opacity"
          >
            <img 
              src="/lovable-uploads/947e619c-1ffe-41fc-a142-ec8ce246d550.png" 
              alt="LexAssess AI Logo" 
              className="h-10 object-contain" 
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default FormLayout;
